import { CSSProperties } from 'react';
import { theme } from '../../theme';

export const installmentOptionStyles = {
  container: {
    width: '100%',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing.small,
    padding: `${theme.spacing.tiny}px ${theme.spacing.medium}px`,
    alignItems: 'center',
    borderBottom: `1px solid ${theme.colors.inputBorder}`,
    backgroundColor: theme.colors.background,
    transition: `all ${theme.transitions.normal}`,
    fontFamily: theme.typography.fontFamily,
  } as CSSProperties,

  radioButton: {
    width: theme.spacing.mediumLarge,
    height: theme.spacing.mediumLarge,
    borderRadius: '50%',
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  } as CSSProperties,

  radioButtonUnselected: {
    backgroundColor: theme.colors.palette.grey100,
    border: `1px solid ${theme.colors.palette.grey350}`,
    opacity: 0.6,
  } as CSSProperties,

  radioButtonSelected: {
    backgroundColor: theme.colors.button.primary,
    border: 'none',
    opacity: 1,
  } as CSSProperties,

  radioDot: {
    width: theme.sizes.dot.width,
    height: theme.sizes.dot.height,
    borderRadius: '50%',
    backgroundColor: theme.colors.white,
  } as CSSProperties,

  radioInput: {
    display: 'none',
  } as CSSProperties,

  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing.tiny,
    flex: 1,
  } as CSSProperties,

  mainRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: theme.spacing.small,
  } as CSSProperties,

  installmentLabel: {
    color: theme.colors.palette.darkGrey200,
    fontSize: theme.typography.fontSize.base,
    fontWeight: theme.typography.fontWeight.normal,
    lineHeight: theme.typography.lineHeight.base,
    fontFamily: theme.typography.fontFamily,
  } as CSSProperties,

  badge: {
    fontSize: 11,
    padding: '2px 8px',
    borderRadius: theme.radius.sm,
    fontWeight: 600,
    fontFamily: theme.typography.fontFamily,
    whiteSpace: 'nowrap',
    backgroundColor: theme.colors.installmentBadge.background,
    color: theme.colors.installmentBadge.text,
  } as CSSProperties,

  flexSpacer: {
    flex: 1,
  } as CSSProperties,

  totalPrice: {
    color: theme.colors.palette.darkGrey200,
    fontSize: theme.typography.fontSize.base,
    fontWeight: theme.typography.fontWeight.bold,
    whiteSpace: 'nowrap',
    fontFamily: theme.typography.fontFamily,
  } as CSSProperties,

  secondRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing.small,
    minHeight: 20,
  } as CSSProperties,

  interestRate: {
    color: theme.colors.subtitle,
    fontSize: theme.typography.fontSize.xs,
    fontWeight: theme.typography.fontWeight.normal,
    lineHeight: '16px',
    letterSpacing: '0%',
    fontFamily: theme.typography.fontFamily,
  } as CSSProperties,

  monthlyDetails: {
    color: theme.colors.palette.darkGrey200,
    fontSize: theme.typography.fontSize.sm,
    fontWeight: theme.typography.fontWeight.normal,
    lineHeight: '20px',
    fontFamily: theme.typography.fontFamily,
  } as CSSProperties,
};
